import { useState } from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const fromISO = (v) => {
  if (!v) return undefined;
  const d = new Date(`${v}T00:00:00`);
  return isNaN(d.getTime()) ? undefined : d;
};

export const DatePicker = ({ value, onChange, placeholder = "Pick a date", className = "", "data-testid": testId, disabled }) => {
  const [open, setOpen] = useState(false);
  const date = fromISO(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" disabled={disabled} data-testid={testId}
          className={`w-full justify-start gap-2 px-3 text-left font-normal ${!date ? "text-muted-foreground" : ""} ${className}`}>
          <CalendarIcon className="h-4 w-4 shrink-0 opacity-60" />
          <span className="truncate">{date ? format(date, "MMM d, yyyy") : placeholder}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={date} defaultMonth={date}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
        {value ? (
          <div className="border-t p-1.5">
            <Button type="button" variant="ghost" size="sm" className="h-7 w-full text-xs text-muted-foreground"
              onClick={() => { onChange(""); setOpen(false); }}>Clear</Button>
          </div>
        ) : null}
      </PopoverContent>
    </Popover>
  );
};
